<ion-header>
  <ion-toolbar>
    <ion-title>{{title}}</ion-title>
    <ion-buttons slot="end">
      <ion-icon *ngIf="isLoggedIn" name="log-out-outline" color="medium" (click)="logout(true)"></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- <h2>For dev team to bypass need to set Community as template</h2>
  <ion-button (click)="copySpecificCommunity()">Copy Specific Community</ion-button> -->

  <!-- Step 1 -->
  <div [id]="1" [hidden]="currentStep != 1" class="children-box w500px">
    <h2>What is your community name?</h2>
    <p>Your community name will be used to generate the web address for your online presence.</p>

    <form>
      <app-text-input [(ngModel)]="newCommunity.name" [required]="true" id="communityName" name="communityname"
        label="Community Name" [maxLength]="100"></app-text-input>

      <ion-item lines="none" class="ion-no-padding">
        <ion-label position="stacked" class="input-label">City, State/Province, Country*</ion-label>
        <input title="City State Country" [required]="true" id="org-map-input" class="google-input"
          name="eroienoiruhgveoiurgvhbn" [(ngModel)]="newCommunity.address1" autocomplete="off">
        <p class="sub-label">
          Start typing and select from suggestions
        </p>
      </ion-item>

      <app-select-input [(ngModel)]="newCommunity.orgTypeId" label="Organization Type" [options]="orgTypeOptions"
        name="orgType" [required]="true" errorDisplay="inline" [includeNullOption]="false"
        nullOptionString="-- Select One --" (onValueSelected)="orgTypeSelected()"></app-select-input>

      <app-text-input [(ngModel)]="newCommunity.otherOrgType" [required]="true" name="otherOrgType" id="otherOrgType"
        name="otherOrgType" *ngIf="orgTypeNameSelected == 'Other'" label="Other Organization Type"
        [maxLength]="200"></app-text-input>
    </form>

    <ion-toolbar>
      <div class="btns">
        <div>
          &nbsp;
        </div>
        <ion-button (click)="onNext()" [disabled]="!formValid()">Next</ion-button>
      </div>
    </ion-toolbar>

  </div>


  <!-- Step 2 -->
  <div [id]="2" [hidden]="currentStep != 2" class="children-box w500px">

    <h2>Login Or Create an Account</h2>

    <app-login-embed [redirectOnLogin]="false" (loginSuccessful)="loginSucceeded()"></app-login-embed>

    <ion-toolbar>
      <div class="btns">
        <ion-button (click)="onPrev()">Back</ion-button>
        <ion-button (click)="onNext()">Next</ion-button>
      </div>
    </ion-toolbar>
  </div>


  <!-- Step 3 - Select demo community if any -->
  <div [id]="3" [hidden]="currentStep != 3" class="children-box maxW800px">


    <div class="templates-container">
      <div class="templates-scroll">

        <h2>Start With Sample Community</h2>
        <p>We've selected a sample community that may be relevant for your organization type.
          Feel free to preview this and other samples, and change your selection if you like.</p>

        <div class="templates">
          <div class="community-card" *ngFor="let template of fullTemplates"
            [class.selected]="selectedTemplateId == template.templateCommunityId">
            <h3>{{template.communityName}}</h3>
            <p>{{template.communityDesc}}</p>
            <div class="flex-spaced">
              <ion-button (click)="open(template.communityUrl)" fill="clear" class="link">Preview</ion-button>
              <ion-button (click)="selectedTemplateId = 0" *ngIf="selectedTemplateId == template.templateCommunityId"
                color="secondary" fill="clear">Selected</ion-button>
              <ion-button (click)="templateSelected(template.templateCommunityId)"
                *ngIf="selectedTemplateId != template.templateCommunityId" color="secondary"
                fill="outline">Select</ion-button>
            </div>
          </div>
          <div *ngIf="fullTemplates.length % 2 !== 0" style="width:calc(50% - 10px);">
            &nbsp;
          </div>
        </div>

        <div class="mt30px"></div>
        <h2>Adding functionality to your existing site?</h2>
        <p>Just looking for an online marketplace or creating and managing events?
          Use CommuniBee to supplement your site as needed
        </p>
        <div class="templates">
          <div class="community-card" *ngFor="let template of narrowTemplates"
            [class.selected]="selectedTemplateId == template.templateCommunityId">
            <h3>{{template.communityName}}</h3>
            <p>{{template.communityDesc}}</p>
            <div class="flex-spaced">
              <ion-button (click)="open(template.communityUrl)" fill="clear" class="link">Preview</ion-button>
              <ion-button (click)="selectedTemplateId = 0" *ngIf="selectedTemplateId == template.templateCommunityId"
                color="secondary" fill="clear">Selected</ion-button>
              <ion-button (click)="templateSelected(template.templateCommunityId)"
                *ngIf="selectedTemplateId != template.templateCommunityId" color="secondary"
                fill="outline">Select</ion-button>
            </div>
          </div>
          <div *ngIf="narrowTemplates.length % 2 !== 0" style="width:calc(50% - 10px);">
            &nbsp;
          </div>
        </div>

      </div>
    </div>

    <ion-toolbar>
      <div class="btns">
        <!-- no more back since community is now already created -->
        <!-- <ion-button (click)="onPrev()">Back</ion-button> -->
        <div></div>
        <div>
          <ion-button (click)="skipTemplates()" fill="clear"><span class="link">Start from scratch</span></ion-button>
          <ion-button (click)="onNext()" [disabled]="selectedTemplateId > 0 == false">Next</ion-button>
        </div>
      </div>
    </ion-toolbar>
  </div>

  <!-- Step 4 - Select available features to include -->
  <div [id]="4" [hidden]="currentStep != 4" class="children-box maxW800px">

    <div class="templates-container">
      <div class="templates-scroll">

        <h2>Fine tune which sample content to include</h2>
        <p>
          Here you can see which features have sample content for the selected template.
          You can un-select features if you don't want specific sample content copied into your community.
        </p>
        <p>
          All features will be available regardless of template or feature are selected!
        <p>
        </p>

        <div class="templates">
          <div class="community-card" *ngFor="let feature of includedFeatures">
            <!-- <img src="feature.imgPath"/> -->
            <h3 class="flex-spaced">
              <span>{{feature.name}}</span>
              <ion-checkbox [(ngModel)]="feature.selected"></ion-checkbox>
            </h3>
            <p>{{feature.description}}</p>
          </div>
          <div *ngIf="includedFeatures.length % 2 !== 0" style="width:calc(50% - 10px);">
            &nbsp;
          </div>
        </div>

        <div class="mt30px"></div>
        <h2>Samples not included in this template</h2>
        <p>
          The sample community you selected doesn’t include the following features.
          However, these features will still be available to you.
        </p>
        <div class="templates">
          <div class="community-card" *ngFor="let feature of excludedFeatures">
            <!-- <img src="feature.imgPath"/> -->
            <h3>
              {{feature.name}}
            </h3>
            <p>{{feature.description}}</p>
          </div>
          <div *ngIf="narrowTemplates.length % 2 !== 0" style="width:calc(50% - 10px);">
            &nbsp;
          </div>
        </div>

      </div>
    </div>

    <ion-toolbar>
      <div class="btns">
        <ion-button (click)="onPrev()">Back</ion-button>
        <div>
          <ion-button (click)="onNext()" [disabled]="selectedTemplateId > 0 == false">Next</ion-button>
        </div>
      </div>
    </ion-toolbar>
  </div>

  <!-- Step 5 - Confirm selected template and features -->
  <div [id]="5" [hidden]="currentStep != 5" class="children-box maxW800px">

    <div class="templates-container">
      <div class="templates-scroll" *ngIf="selectedTemplate != null">

        <h2>Confirm Sample Content to Include</h2>
        <p>
          Here is a summary of the sample content you have selected to copy into your community.
        </p>

        <h3 class="mtb20px">Features to copy from: {{selectedTemplate.communityName}}</h3>
        <div class="templates">
          <ng-container *ngFor="let feature of includedFeatures">
            <div class="community-card" *ngIf="feature.selected">
              <!-- <img src="feature.imgPath"/> -->
              <h3 class="flex-spaced">
                <span>{{feature.name}}</span>
              </h3>
              <p>{{feature.description}}</p>
            </div>
          </ng-container>
        </div>

      </div>
    </div>

    <ion-toolbar>
      <div class="btns">
        <ion-button (click)="onPrev()">Back</ion-button>
        <div>
          <ion-button (click)="onNext()" [disabled]="selectedTemplateId > 0 == false">Confirm</ion-button>
        </div>
      </div>
    </ion-toolbar>
  </div>


  <!-- Step 6 - Select subscription -->
  <div [id]="6" [hidden]="currentStep != 6" class="children-box maxW1000px">

    <div class="templates-container">
      <div class="templates-scroll">

        <section id="select-subscription">
          <app-manage-subscription>
            <ng-template #customTemplate>
              <p>
                By subscribing to CommuniBee you will unlock access to additional functionality and lower eCommerce
                rates!
              </p>
              <p>
                All features will be available regardless of template or feature are selected!
              <p>
              </p>
            </ng-template>
          </app-manage-subscription>
        </section>

      </div>
    </div>

    <ion-toolbar>
      <div class="btns">

        <div>
          <!-- only allow back if templates was skipped-->
          <ion-button *ngIf="selectedTemplateId == 0" (click)="onPrev(3)">Back</ion-button>
        </div>
        <ion-button (click)="onNext()" [disabled]="selectedTemplateId >= 0 == false">Finish</ion-button>
      </div>
    </ion-toolbar>
  </div>

</ion-content>